
<div
  :class="
    classes(
      n(),
      n(`--${layout}`),
      n(`--theme-default--${layout}`),
    )
  "
  aria-hidden="true"
  role="separator"
>
</div>
